import * as React from 'react';
import { init } from './init-app';
import SiteApp from './components/App/SiteApp';

init(<SiteApp />);
